<template>
  <wrapper>
    <div class="flex flex-col w-full">
      <p class="w-full mb-2 font-bold">
        Orders to be imported:
        {{ new Intl.NumberFormat().format(orderDataLength) }}
      </p>
    </div>
    <expandabel-table
      :text="'Orders Data:'"
      :columnsToNotSort="columnsToNotSort"
      :headers="headers"
      :data="orderData"
      :useSearch="false"
    >
      <template v-slot:column="{ column, child }">
        <p>{{ child[column] }}</p>
      </template>
      <template v-slot:child="{ child }">
        <div class="flex flex-col w-full">
          <p class="w-full mb-2 font-bold">Group data</p>
          <div class="flex p-4 rounded-lg bg-primary-light">
            <div class="flex flex-col flex-1">
              <span class="text-xs font-bold">Group Strategy</span>
              <span class="text-gray-light">{{ child.groupStrategy }}</span>
            </div>
          </div>
          <p class="w-full mb-2 font-bold">Order Data</p>
          <div class="flex flex-col p-4 rounded-lg bg-primary-light">
            <div
              class="flex p-4 my-2 rounded-lg bg-primary-dark"
              v-for="(data, index) in child.orderData"
              :key="index"
            >
              <span class="flex-1">{{ data.key }}</span>
              <span class="flex-1">{{ data.data }}</span>
            </div>
          </div>
          <h3 class="article-title">
            Articles
          </h3>
          <div v-for="(article, index) in child.articles" :key="index">
            <p class="w-full mb-2 font-bold">{{ article.name }}</p>
            <div class="flex flex-col p-4 rounded-lg bg-primary-light">
              <div class="flex items-center w-full">
                <div class="flex flex-col flex-1">
                  <span class="text-xs font-bold">External Identifier</span>
                  <span class="text-gray-light">{{
                    article.externalIdentifier
                  }}</span>
                </div>
                <div class="flex flex-col flex-1">
                  <span class="text-xs font-bold">Article Strategy</span>
                  <span class="text-gray-light">{{
                    getStrategy(article.articleStrategy)
                  }}</span>
                </div>
                <div class="flex flex-col flex-1">
                  <span class="text-xs font-bold">Quantity</span>
                  <span class="text-gray-light">{{ article.quantity }}</span>
                </div>
              </div>
              <div class="flex items-center w-full mt-4">
                <div class="flex flex-col flex-1">
                  <span class="text-xs font-bold">Group Strategy</span>
                  <span class="text-gray-light">{{
                    getStrategy(article.groupStrategy)
                  }}</span>
                </div>
                <div class="flex flex-col flex-2">
                  <span class="text-xs font-bold">Groups</span>
                  <span
                    class="text-gray-light"
                    v-if="article.groupIds && article.groupIds.length"
                  >
                    {{ getGroupNames(article.groupIds) }}
                  </span>
                </div>
              </div>
              <div class="flex flex-col w-full mt-4">
                <div
                  class="flex items-center article-data-header"
                  v-on:click="toggleArticleData(child.articles, index)"
                >
                  <span>Article Data</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-5 h-5 ml-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
                <div
                  class="p-4 mt-4 rounded-lg bg-primary-dark"
                  v-if="article.showData"
                >
                  <div
                    class="flex w-full"
                    v-for="(articleData, dataIndex) in article.articleData"
                    :key="dataIndex"
                  >
                    <p class="flex-1">{{ articleData.key }}</p>
                    <p class="flex-1">{{ articleData.data }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </expandabel-table>
    <div class="flex flex-col items-center w-full">
      <button
        type="button"
        class="flex items-center mr-8 text-lg text-white underline bg-transparent border-none cursor-pointer"
        @click="loadMore()"
        v-if="orderDataLength > this.orderData.length"
      >
        Load more...
      </button>
    </div>
  </wrapper>
</template>

<script>
import ExpandabelTable from "./ExpandabelTable.vue";

export default {
  components: { ExpandabelTable },
  props: {
    orders: Array,
    getStrategy: Function,
    getGroupNames: Function,
  },
  data() {
    return {
      columnsToNotSort: [],
      headers: {
        orderReference: "Order Ref.",
        orderStrategy: "Strategy",
      },
      orderData: [],
      orderDataLength: 0,
      page: 1,
    };
  },
  methods: {
    toggleArticleData(articles, index) {
      articles[index].showData = !articles[index].showData;
    },
    loadMore() {
      this.page += 1;
      this.loadData();
    },
    loadData() {
      const pageSize = 10;
      const paginatedResult = this.orders
        .slice((this.page - 1) * pageSize, this.page * pageSize)
        .map((order, index) => ({
          id: index + this.page * pageSize,
          orderReference: order.orderReference,
          orderStrategy: this.getStrategy(order.orderStrategy),
          expandableData: {
            groupStrategy: this.getStrategy(order.groupStrategy),
            articles: order.articles.map(x => ({ ...x, showData: false })),
            orderData: order.orderData,
          },
        }));

      this.orderData.push(...paginatedResult);
    },
  },
  beforeMount() {
    this.orderDataLength = this.orders.length;
    this.loadData();
  },
};
</script>

<style></style>
